import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import '@moncler/scss/components/secondary-navigation-genius/secondary-navigation.scss';
import classNames from 'classnames';
const SecondaryNavigationGenius = (props) => {
    const { t } = useTranslation();
    const [componentData, setComponentData] = useState(null);
    const [lastScroll, setLastScroll] = useState(0);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                let componentDataMerged = Object.assign(Object.assign({}, componentDataRes.data), { custom: componentDataRes.custom });
                setComponentData(componentDataMerged);
                console.log('componentDataMerged', componentDataMerged);
            });
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        if (window.appmode) {
            document.body.dataset.scroll = 'top';
            handleScroll();
            window.addEventListener('scroll', handleScroll);
        }
    }, []);
    const handleResize = () => {
        const header = document.querySelector('header');
        let headerHeight = header && header.getBoundingClientRect().height;
        if (headerHeight) {
            document.body.style.setProperty('--header-height', `${headerHeight / 10}rem`);
        }
    };
    const handleScroll = () => {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        // if page is on top add a class to body
        if (currentScroll === 0 || currentScroll < 0) {
            document.body.dataset.scroll = 'top';
        }
        else {
            if (currentScroll > 0 && lastScroll <= currentScroll) {
                setLastScroll(currentScroll);
                document.body.dataset.scroll = 'down';
            }
            else {
                setLastScroll(currentScroll);
                document.body.dataset.scroll = 'up';
            }
        }
    };
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "secondary-navigation-module" },
        React.createElement("a", { href: componentData.cta_link, className: classNames('button', 'button--tertiary-inverted', 'button--arrow-left') },
            React.createElement("span", { className: `icon--genius-white` }),
            componentData.cta)));
};
export default SecondaryNavigationGenius;
